import {AppAdmissionListener, Keypad, KeypadListener} from "@variocube/app-api";
import {AccessCode, AdmissionRequest, AppAdmissionRequestGranted, KeypadMessageTypes} from "@variocube/driver-common";
import {VcmpClient} from "@variocube/vcmp";
import {isThisUnit} from "./unit";

export class ControllerKeypad implements Keypad {

    private client: VcmpClient;

    private keypadListeners = new Set<KeypadListener>();
    private admissionListeners = new Set<AppAdmissionListener>();

    constructor(url: string) {
        this.client = new VcmpClient(url);
        this.client.on(KeypadMessageTypes.AccessCode, this.handleAccessCode);
        this.client.on(KeypadMessageTypes.AppAdmissionRequest, this.handleAppAdmissionRequest);
        this.client.start();
    }

    addKeypadListener(listener: KeypadListener) {
        this.keypadListeners.add(listener);
    }

    removeKeypadListener(listener: KeypadListener) {
        this.keypadListeners.delete(listener);
    }

    addAppAdmissionListener(listener: AppAdmissionListener) {
        this.admissionListeners.add(listener);
    }

    removeAppAdmissionListener(listener: AppAdmissionListener) {
        this.admissionListeners.delete(listener);
    }

    private handleAccessCode = ({code, unit}: AccessCode) => {
        console.info("Access code entered: ", {code, unit});
        if (isThisUnit(unit)) {
            this.keypadListeners.forEach(listener => listener({code}));
        }
        else {
            console.info("Ignoring barcode from another unit");
        }
    };

    private handleAppAdmissionRequest = async (request: AdmissionRequest) => {
        console.info('App admission request received: ', request);

        for (let listener of this.admissionListeners) {
            try {
                const result = await listener(request);
                if (result) {
                    console.info('Detected positive result from listener. Opening admission box');
                    await this.client.send<AppAdmissionRequestGranted>({
                        ...result,
                        "@type": KeypadMessageTypes.AppAdmissionRequestGranted,
                    });
                    return;
                }
            } catch (err) {
                console.error('Cannot detect listener result.', err);
            }
        }
        console.log('No positive result found. Box not open.')
    }
}
